'use strict';
angular
    .module('dnapp')
    .factory('DN.MailingListService', ['$resource', function ($resource) {
        return $resource('/umbraco/api/MailingListApi/:action', {}, {
            Subscribe: { method: "POST", params: { action: "Subscribe" }, isArray: true },
            UnSubscribe: { method: "POST", params: { action: "UnSubscribe" }, isArray: true },
            Subscriptions: { method: "GET", params: { action: "SubscriberLists" }, isArray: true }
        });
    }]);